import { toast } from "sonner";
import { motion } from "framer-motion";
import { LineReveal } from "./Motion";
import { Mark } from "./Logo";
import { profile } from "../data/projects";
import { scrollToTarget, useClock } from "../lib/smooth";

export const Contact = () => {
  const time = useClock();
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(profile.email);
      toast.success("Email copied to clipboard");
    } catch {
      toast(profile.email);
    }
  };
  return (
    <footer id="contact" className="relative overflow-hidden bg-ink px-5 pb-8 pt-24 text-paper md:px-10 md:pt-36" data-testid="contact-section">
      <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-stone-400">(04) Get in touch</p>
      <LineReveal
        as="h2"
        inView
        className="mt-8 font-display text-[14vw] font-semibold leading-[0.88] tracking-[-0.06em] md:text-[9vw]"
        lines={["Let\u2019s make", <>something <em className="font-serif font-normal italic">great.</em></>]}
      />
      <div className="mt-14 flex flex-wrap items-center gap-4 md:mt-20">
        <a href={`mailto:${profile.email}`} className="email-link font-display text-2xl font-medium tracking-[-0.03em] sm:text-4xl md:text-6xl" data-testid="footer-email-link">
          {profile.email}
        </a>
        <motion.button whileTap={{ scale: 0.94 }} onClick={copy} className="rounded-full border border-stone-600 px-5 py-3 font-mono text-[11px] uppercase tracking-[0.18em] text-stone-300 transition-colors duration-300 hover:border-paper hover:bg-paper hover:text-ink" data-testid="footer-copy-email-button">
          Copy
        </motion.button>
        <a href="/Ravin_Patel_CV.pdf" download className="rounded-full bg-[#D2491F] px-5 py-3 font-mono text-[11px] uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:bg-paper hover:text-ink" data-testid="footer-download-cv-btn">
          Download CV ↧
        </a>
      </div>
      <div className="mt-24 grid grid-cols-2 gap-8 border-t border-stone-700 pt-8 md:mt-36 md:grid-cols-4">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-stone-400">Socials</p>
          <ul className="mt-3 space-y-1">
            {profile.socials.map((s) => (
              <li key={s.label}><a href={s.href} target="_blank" rel="noreferrer" className="nav-link text-paper" data-testid={`footer-social-${s.label.toLowerCase()}`}>{s.label} ↗</a></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-stone-400">Local time</p>
          <p className="mt-3 tabular-nums" data-testid="footer-clock">UK {time}</p>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-stone-400">Role</p>
          <p className="mt-3">{profile.role}</p>
        </div>
        <div className="flex items-start justify-end">
          <button onClick={() => scrollToTarget(0)} className="nav-link font-mono text-[11px] uppercase tracking-[0.18em]" data-testid="footer-back-to-top">Back to top ↑</button>
        </div>
      </div>
      <div className="mt-16 flex items-end justify-between gap-6">
        <Mark className="h-10 w-10 text-[#EFECE6] [--paper:#141414] [--accent:#D2491F]" />
        <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-stone-400">© {new Date().getFullYear()} Ravin Patel</p>
      </div>
    </footer>
  );
};
